<div class="flex h-full items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full">
      <div>
        <!-- <img class="mx-auto h-12 w-auto" src="/img/logos/workflow-mark-on-white.svg" alt="Workflow" /> -->
        <h2 class="text-center text-3xl leading-9 font-extrabold text-blue-500">
          <span class="text-yellow-400">  Reset Link </span> sent.
        </h2>

      </div>


            <div class="mt-4">
                <p class="text-xl leading-snug font-semibold text-gray-600 text-center"> We sent you an email with instructions on how to proceed </p>
                <p class="text-sm mt-2">  If you can't see the mail in your inbox please check your spam folder </p>
            </div>


          <div class="flex items-center justify-between mt-4">
            <div class="flex items-center">

            </div>
    
            <div class="text-sm">
              <a [routerLink]="['../../sign-in']" class="font-medium text-blue-600 hover:text-blue-500">
                Back to login?
              </a>
            </div>
          </div>

        <div *ngIf="!emailSentAgain">
          <br/>
          <button (click)="sendEmailAgain()"  class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-500 focus:outline-none focus:border-blue-600 focus:ring-blue active:bg-blue-600 hover:bg-blue-400 transition duration-150 ease-in-out">
            Send Again
          </button>
        </div>
        <!--  <div class="mt-6">
            <button type="submit" [disabled]="form.invalid" [class.opacity-50]="form.invalid" [class.hover:bg-blue-400]="form.valid" class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-500 focus:outline-none focus:border-blue-600 focus:ring-blue active:bg-blue-600 transition duration-150 ease-in-out">
              <span class="absolute left-0 inset-y pl-3">
                <svg class="h-5 w-5 text-blue-500 group-hover:text-blue-400 transition ease-in-out duration-150" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd" />
                </svg>
              </span>
              Send
            </button>
          </div> -->


    </div>
  </div>

